import React, {useState} from "react"
import classNames from "classnames"
import {connect} from "react-redux"
import {Tooltip} from "@material-ui/core";
import {Button} from "react-bootstrap"
import CheckoutModal from "./CheckoutModal";
import {processableFrames} from "../../../helpers/cartHelper";
import {DownloadType, JobType} from "../../../types/cart";
import {AllInterferometricStacksType, ProductImageStacType} from "../../../types/product";
import {ConfigurationsType} from "../../../types/configurations";
import {ShapeType} from "../../../types/shape";
import {getMainInputConfigurationsBy} from "../../../helpers/searchHelper";
import {getScopeConfigurationFieldsBy} from "../../../helpers/configurationHelper";
import {isInterferometricStackSearchResults} from "../../../helpers/searchResultsHelper";
import Loader from "../Loader";
import {DEFAULT_TOOLTIP_PROPS} from "../../../helpers/tooltipHelper";
import {AppParametersType} from "../../../types/app";
import translations from "../../../translations";

interface PropsType {
    configurations: ConfigurationsType,
    products: ProductImageStacType[],
    isButtonVisible: boolean,
    forwardRef: any,
    buttonText?: string,
    modalText?: string,
    formData: any,
    lastShape: ShapeType,
    allInterferometricStacks: AllInterferometricStacksType,
    isInterferometricStackOrder: boolean,
    appParameters: AppParametersType,
    language: string,
    cutscenes: any,
    isFramingViewActive: boolean
}

const CheckoutButton = (props: PropsType) => {
  const {
    configurations,
    lastShape,
    products,
    formData,
    isButtonVisible = true,
    forwardRef,
    buttonText: defaultButtonText,
    modalText,
    allInterferometricStacks,
    isInterferometricStackOrder,
    appParameters,
    language,
    cutscenes,
    isFramingViewActive
  } = props;

  const [isLoading, setIsLoading] = useState(false);

  const mainInputConfigurations = getMainInputConfigurationsBy(configurations, appParameters);
  const scopeConfigurationFields = getScopeConfigurationFieldsBy(configurations);

  // @mapitaly preparo il job oppure i downloads
  const [job, setJob] = useState<JobType | null>(null);
  const [downloads, setDownloads] = useState<DownloadType[] | null>(null);

  const onCloseHandler = () => {
    setJob(null);
    setDownloads(null);
  };

  const onClickHandler = () => {
    setIsLoading(true);
    if (formData.routine) {
      // devo popolare downloads (con setDownloads()) per mostrare la modale di checkout in cui ci sarà poi la logica corretta
      const newDownloads: DownloadType[] = [];
      products.forEach((product) => {
        newDownloads.push({
          id: product.id,
          filename: product.assets && product.assets.image ? product.assets.image.href : ""
        });
      });
      setDownloads(newDownloads);
    } else {
      // devo popolare job (con setJob()) per mostrare la modale di checkout in cui ci sarà poi la logica corretta
      const frames: any[] = processableFrames(products, cutscenes, lastShape);
      const itemList = products.map((product) => product.id);
      const newJob: JobType = {
        arguments: {
          frames: {
            features: frames,
            type: "FeatureCollection"
          },
        },
        item_list: itemList,
        process_id: "OnDemand",
        description: ""
      };
      setJob(newJob);
    }
    setIsLoading(false);
  };

  let isButtonDisabled = true;
  let buttonContext;
  if (isLoading) {
    buttonContext = <Loader spinnerClassName="button-size" />;
  } else {
    let buttonText;
    if (defaultButtonText) {
      buttonText = defaultButtonText;
    } else if (formData.routine) { // @mapitaly in base al search mode mostro una diversa etichetta e logica disabled
      isButtonDisabled = !products || products.length === 0;
      buttonText = products.length > 0
        ? `${translations("downloadProducts", language)} (${products.length})`
        : translations("downloadProducts", language)
    } else {
      // conto il numero di frames processabili
      const frames: any[] = isFramingViewActive ? processableFrames(products, cutscenes, lastShape) : [];
      isButtonDisabled = !isFramingViewActive || (!frames || frames.length === 0);
      buttonText = frames.length > 0
        ? `${translations("processProducts", language)} (${frames.length})`
        : translations("processProducts", language)
    }
    buttonContext = <span>{buttonText}</span>;
  }

  let tooltipTitle = ";"
  if (isButtonDisabled) {
    tooltipTitle = translations("selectAtLeastOneItem", language);
  } else {
    tooltipTitle = formData.routine ? translations("downloadProducts", language) : translations("processProducts", language);
  }

  return (
    <>
      <div className={classNames({"d-none": !isButtonVisible})}>
        <Tooltip
          {...DEFAULT_TOOLTIP_PROPS}
          title={tooltipTitle}
          placement="top"
        >
          <span>
            <Button
              ref={forwardRef}
              disabled={isButtonDisabled}
              style={isButtonDisabled ? {pointerEvents: "none"} : {}}
              onClick={onClickHandler}
            >
              {buttonContext}
            </Button>
          </span>
        </Tooltip>
      </div>
      {(downloads || job) && (
        <CheckoutModal
          handleClose={onCloseHandler}
          job={job}
          downloads={downloads}
          modalText={modalText}
        />
      )}
    </>
  )
};

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  formData: state.application.formData,
  lastShape: state.geoMap.lastShape,
  allInterferometricStacks: state.product.allInterferometricStacks,
  isInterferometricStackOrder: isInterferometricStackSearchResults(state.product.searchResults),
  appParameters: state.application.appParameters,
  language: state.application.appParameters.language,
  cutscenes: state.geoMap.availableCutScenes,
  isFramingViewActive: state.product.isFramingViewActive
});

export default connect(mapStateToProps)(CheckoutButton)
